/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const e = (n, a) => {
  if (n && n.chartInstance !== null)
    return n.chartInstance.findAxisByName(a);
}, s = (n, a) => {
  if (n && n.chartInstance !== null)
    return n.chartInstance.findPaneByIndex(a);
}, i = (n, a) => {
  if (n && n.chartInstance !== null)
    return n.chartInstance.findPaneByName(a);
}, c = (n, a = {}) => {
  if (n && n.chartInstance !== null)
    return n.chartInstance.exportVisual(a);
};
export {
  c as exportVisual,
  e as findAxisByName,
  s as findPaneByIndex,
  i as findPaneByName
};
